/**
 * usePendingBrandsCount — compteur badge pour le ModuleSelector (REFONTE-RD12).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPendingBrandsCount } from '../lib/api';

export function usePendingBrandsCount() {
  return useQuery({
    queryKey: ['admin', 'pending-brands-count'],
    queryFn:  fetchPendingBrandsCount,
    staleTime: 60_000,
    // Ne pas bloquer le rendu si le serveur est absent
    retry: 1,
  });
}
